<template>
  <div class="h-100">
    <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
      <v-card-title class="pb-0">
        <v-icon color="secondary" large class="mr-2">remove_red_eye</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.myFavorites")}}</span>
          <span
            class="subheader-font body-2"
          >{{$t('dashboards.lastAdded')}}</span>
        </div>
      </v-card-title>
      <v-tabs v-model="tabModel" class="my-0" grow color="secondary darken-1">
        <v-tab>{{$t('general.players')}}</v-tab>
        <v-tab>{{$t('playerScout.teams')}}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabModel" style="background:transparent" class="flex-grow-1 overflow-auto h-100">
        <v-tab-item class="h-100">
          <template>
            <div class="d-flex flex-column h-100">
              <div class="d-flex flex-column pl-5 pr-3 pb-1 flex-grow-1" v-if="(players && players.length) && !loading" style="overflow:auto;">
                <PlayerDashboardItem :player="player" v-for="(player,index) in players" :key="index" embedded></PlayerDashboardItem>
              </div>
              <div class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1" v-if="(!players || !players.length) && !loading">
                <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">star</v-icon>
                <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderFavorites")}}</span>
              </div>
              <v-skeleton-loader v-if="loading" type="list-item@10" class="flex-grow-1"></v-skeleton-loader>
              <v-divider class="my-1"></v-divider>
              <div class="d-flex justify-end px-2 py-2">
                <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/favorites`">{{$t('dashboards.seeAllFavorites')}}</v-btn>
              </div>
            </div>
          </template>
        </v-tab-item>
        <v-tab-item class="h-100">
          <template>
            <div class="d-flex flex-column h-100">
              <div class="d-flex flex-column pl-5 pr-3 pb-1 flex-grow-1" v-if="(teams && teams.length) && !loading" style="overflow:auto;">
                <div class="d-flex justify-space-between align-center"  v-for="(team,index) in teams" :key="index">
                  <router-link
                    :to="'/team/'+team.teamId"
                    class="nav-link d-flex align-center py-1"
                  >
                    <img @error="onImageLoadFailure($event,'team')"
                      :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + team.teamId + '.png'"
                      style="height: 22px; width: 22px;"
                    />
                    <div
                      class="mx-2 body-1 text-ellipsis"
                      v-bind:style="{'max-width': !$vuetify.breakpoint.xlOnly ? '120px' :''}"
                    >{{team.teamName}}</div>
                  </router-link>
                  <span class="body-2">{{team.leagueName}}</span>
                </div>
              </div>
              <div class="d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1" v-if="(!teams || !teams.length) && !loading">
                <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">star</v-icon>
                <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderTeamFavorites")}}</span>
              </div>
              <v-skeleton-loader v-if="loading" type="list-item@10" class="flex-grow-1"></v-skeleton-loader>
              <v-divider class="my-1"></v-divider>
              <div class="d-flex justify-end px-2 py-2">
                <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/team-favorites`">{{$t('dashboards.seeAllFavorites')}}</v-btn>
              </div>
            </div>
          </template>
        </v-tab-item>
      </v-tabs-items>
      
    </v-card>
  </div>
</template>

<script>
import PlayerService from "../../../services/player/player.service";
import TeamService from "../../../services/team/team.service";
import PlayerDashboardItem from '../../player/PlayerDashboardItem';

export default {
  name: "FavoritesWidget",
  components:{
    PlayerDashboardItem
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      players: null,
      teams: null,
      tabModel: 0,
      loading: false
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {
      this.loadFavorites();
    },
    async loadFavorites() {
      this.loading = true;
      let onlySelf = true;
      let favoritesResponse =  await PlayerService.getFollowedPlayers(this.userId,onlySelf);
      this.players = _.slice(favoritesResponse.data,0,10);
      let teamFavoritesResponse =  await TeamService.getFollowedTeams(this.userId,onlySelf);
      this.teams = _.slice(teamFavoritesResponse.data,0,10);
      this.loading = false;
    },
    onImageLoadFailure(event, type) {
      if (type === "league" || type === "team") {
        event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0_1.png";
      } else if (type === "player") {
        event.target.src =
          "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png";
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/FavoritesWidget.vue